import React from "react";
import Translator from "Languages/Utility/Translator";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";
import TotalStatistics from "./components/TotalStatistics/TotalStatistics";

export default function StatisticsIndex() {
  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <PageTitle title={<Translator id="sami_statistics" />} />
      </div>
      <TotalStatistics />
    </>
  );
}
